import { Component } from '@angular/core';

import { Permission, SecurityScope } from '../../../auth/auth.model';
import { AuthService } from '../../../auth/auth.service';
import { TaskListDialogService } from '../dialog';

import { TranslationKeyMap } from './task-list-nav-button.i18n';

@Component({
    selector: 'cmps-teamscall-task-list-nav-button',
    templateUrl: './task-list-nav-button.component.html',
    host: {
        class: 'cmps-teamscall-task-list-nav-button',
        '[class.cmps-teamscall-task-list-nav-button--disabled]': '!_hasButton',
    },
})
export class TaskListNavButtonComponent {
    /** @private */ _i18n = TranslationKeyMap;

    /** @private */ _hasButton: boolean;

    constructor(
        /** @private */ readonly _dialogService: TaskListDialogService,
        private readonly _authService: AuthService,
    ) {
        this._hasButton = this._authService.user.hasPermission(
            Permission.TEAMS_CALL_VIEW_TASKS,
            SecurityScope.COACHING,
        );
    }
}
